// Projekt → Modul Deep-Links: Aus der Projekt-Detailansicht ein Modul
// (KV, Zahlungsjournal, Rechnungsprüfung …) mit vorgewähltem Projekt öffnen.
// Gegenstück: consumeModulePreselect() im Ziel-Modul, ModuleBacklinkBar in App.jsx.

const PRESELECT_KEY = 'module_preselect'
const BACKLINK_KEY = 'module_backlink'

/**
 * Navigiert zu einer Modul-Seite und hinterlegt das Projekt als Vorauswahl.
 * @param {string} pageId - Seiten-Key aus App.jsx-Routing (z.B. 'zahlungsjournal')
 * @param {object} project - { id, name, project_number }
 * @param {string} [originTab] - Projekt-Detail-Tab, von dem aus gesprungen wurde
 *   (z.B. 'baukosten') — der Rückweg landet dann wieder auf genau diesem Tab
 */
export function openModuleFromProject(pageId, project, originTab) {
  try {
    const payload = {
      page: pageId,
      project_id: project.id,
      project_name: project.name || '',
      project_number: project.project_number || project.number || '',
      origin_tab: originTab || '',
    }
    sessionStorage.setItem(PRESELECT_KEY, JSON.stringify(payload))
    sessionStorage.setItem(BACKLINK_KEY, JSON.stringify(payload))
  } catch { /* sessionStorage voll/gesperrt — Navigation trotzdem */ }
  window.location.hash = '#/' + pageId
}

/**
 * Liest die Projekt-Vorauswahl für eine Modul-Seite (einmalig, danach gelöscht).
 * @param {string} pageId
 * @returns {{project_id:number, project_name:string, project_number:string}|null}
 */
export function consumeModulePreselect(pageId) {
  try {
    const raw = sessionStorage.getItem(PRESELECT_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (data.page !== pageId) return null
    sessionStorage.removeItem(PRESELECT_KEY)
    return data
  } catch { return null }
}

/** Aktiven Rückweg lesen (bleibt bestehen, bis Seite gewechselt oder benutzt). */
export function getModuleBacklink() {
  try {
    const raw = sessionStorage.getItem(BACKLINK_KEY)
    return raw ? JSON.parse(raw) : null
  } catch { return null }
}

export function clearModuleBacklink() {
  try { sessionStorage.removeItem(BACKLINK_KEY) } catch { /* ignore */ }
}

/**
 * Zur Projektseite navigieren ('#/projekt/<id>', eigene Route) —
 * die eine Stelle, an der diese Route zusammengebaut wird.
 * @param {number|string} projectId
 * @param {string} [tab] - Ziel-Tab der Projektseite (z.B. 'baukosten')
 */
export function gotoProjekt(projectId, tab) {
  window.location.hash = '#/projekt/' + projectId + (tab ? '?tab=' + encodeURIComponent(tab) : '')
}

/**
 * Zurück zur Projektseite. Mit originTab landet der User wieder auf genau
 * dem Tab, von dem er kam.
 */
export function backToProject(projectId, originTab) {
  try { sessionStorage.removeItem(BACKLINK_KEY) } catch { /* ignore */ }
  gotoProjekt(projectId, originTab)
}
